import { FieldArray } from 'formik';
import React from 'react';
import { SectionLine } from '../components/SectionLine';
import { FormikPremiumInput } from 'refactored/features/emergencies/ui/inputs/customInput';
import { FieldArrayButton } from '../components/FieldArrayButton';
import TotalsSeparator from '../components/TotalsSeparator';
import TotalsLine from '../components/TotalsLine';
import TotalsText from '../components/TotalsText';
import { SectionContainer } from '../components/SectionContainer';
import SectionTitle from '../components/SectionTitle';
import { SectionBody } from '../components/SectionBody';
import { ReactComponent as FieldArrayAddIcon } from 'assets/icons/field-array-add.svg';
import { ReactComponent as FieldArrayRemoveIcon } from 'assets/icons/field-array-remove.svg';
import ticketService from 'refactored/features/emergencies/ticket-service';
import { withTranslation } from 'react-i18next';

const LoadsList = ({ ticketFormBodyData }) => {
  const loads = ticketFormBodyData.values.order_data.loads_data.loads;
  return (
    <>
      <FieldArray
        name="order_data.loads_data.loads"
        render={(arrayHelpers) => (
          <>
            {loads.map((load, index) => (
              <SectionLine>
                <LoadForm
                  key={index}
                  load={load}
                  index={index}
                  arrayHelpers={arrayHelpers}
                  ticketFormBodyData={ticketFormBodyData}
                />
              </SectionLine>
            ))}
          </>
        )}
      />
    </>
  );
};

const LoadForm = withTranslation('Emergencies')(
  ({ key, load, index, arrayHelpers, ticketFormBodyData, t }) => {
    const { showErrors, isEdit, isReadOnly } = ticketFormBodyData;
    return (
      <>
        <FormikPremiumInput
          type={'number'}
          isRequired={true}
          label={t('units')}
          showErrors={showErrors}
          name={`order_data.loads_data.loads.${index}.number_of_items`}
          width={'80px'}
          isDisabled={isEdit || isReadOnly}
        />

        <FormikPremiumInput
          label={t('type')}
          showErrors={showErrors}
          name={`order_data.loads_data.loads.${index}.load_type`}
          type={'select'}
          isRequired={true}
          isDisabled={isEdit || isReadOnly}
          availableOptions={[
            {
              value: 'eupallet',
              label: t('eu_pallet'),
            },
            {
              value: 'americanpallet',
              label: t('american_pallet'),
            },
            {
              value: 'cage',
              label: t('cage'),
            },
            {
              value: 'envelope',
              label: t('envelope'),
            },
            {
              value: 'box',
              label: t('box'),
            },
            {
              value: 'suitcase',
              label: t('suitcase'),
            },
            {
              value: 'drum',
              label: t('drum'),
            },
            {
              value: 'aero',
              label: t('aero'),
            },
            {
              value: 'rolls',
              label: t('rolls'),
            },
            {
              value: 'others',
              label: t('others'),
            },
          ]}
        />
        <FormikPremiumInput
          type={'number'}
          label={t('width')}
          units={'cm'}
          isDisabled={isEdit || isReadOnly}
          showErrors={showErrors}
          name={`order_data.loads_data.loads.${index}.item_width`}
          width={'100px'}
        />
        <FormikPremiumInput
          type={'number'}
          label={t('length')}
          units={'cm'}
          isDisabled={isEdit || isReadOnly}
          showErrors={showErrors}
          name={`order_data.loads_data.loads.${index}.item_length`}
          width={'100px'}
        />
        <FormikPremiumInput
          type={'number'}
          label={t('height')}
          units={'cm'}
          isDisabled={isEdit || isReadOnly}
          showErrors={showErrors}
          name={`order_data.loads_data.loads.${index}.item_height`}
          width={'100px'}
        />
        {!isEdit && !isReadOnly && index === 0 && (
          <FieldArrayButton
            onClick={(e) => {
              arrayHelpers.push(ticketService.defaultValues.getDefaultLoad());
            }}
          >
            <FieldArrayAddIcon />
          </FieldArrayButton>
        )}
        {!isEdit && !isReadOnly && index > 0 && (
          <FieldArrayButton
            onClick={(e) => {
              return arrayHelpers.remove(index);
            }}
          >
            <FieldArrayRemoveIcon />
          </FieldArrayButton>
        )}
      </>
    );
  }
);

const TotalLoads = withTranslation('Emergencies')(
  ({ ticketFormBodyData, t }) => {
    const { showErrors, isEdit, isReadOnly } = ticketFormBodyData;

    return (
      <>
        <TotalsSeparator>
          <TotalsLine />
          <TotalsText>{t('total')}</TotalsText>
          <TotalsLine />
        </TotalsSeparator>
        <SectionLine>
          <FormikPremiumInput
            label={t('weight')}
            isRequired={true}
            name="order_data.loads_data.totals.total_weight"
            showErrors={showErrors}
            type="number"
            units={'kg'}
            min={0}
            isDisabled={isEdit || isReadOnly}
          />
          <FormikPremiumInput
            label={t('volume')}
            name="order_data.loads_data.totals.cubic_meters"
            showErrors={showErrors}
            isRequired={false}
            type="number"
            units={'m³'}
            min={0}
            isDisabled={isEdit || isReadOnly}
          />
          <FormikPremiumInput
            label={t('linear_meters')}
            name="order_data.loads_data.totals.linear_meters"
            showErrors={showErrors}
            isRequired={false}
            type="number"
            units={'m'}
            min={0}
            isDisabled={isEdit || isReadOnly}
          />
        </SectionLine>
      </>
    );
  }
);

export const LoadSection = withTranslation('Emergencies')(
  ({ ticketFormBodyData, t }) => {
    return (
      <>
        <SectionContainer>
          <SectionTitle>{t('load_form')}</SectionTitle>
          <SectionBody>
            <LoadsList ticketFormBodyData={ticketFormBodyData} />
            <TotalLoads ticketFormBodyData={ticketFormBodyData} />
          </SectionBody>
        </SectionContainer>
      </>
    );
  }
);
